module.exports = __webpack_public_path__ + "img/884-2560f4.png";